import usersActionCreators from "Areas/Settings/users/redux/actionCreators";
import { connect } from "react-redux";
import parentActionCreators from "../accessLevels/redux/actionCreators";
import { getAccessLevels, getInProgress } from "../accessLevels/redux/selectors";
import AccessLevelEditorPanel from "./accessLevelsEditorPanel";
import actionCreators from "./redux/actionCreators";
import { getAccessLevelsKey } from "./redux/selectors";
const mapStateToProps = (state, ownProps) => ({
    inProgress: getInProgress(state, ownProps.entityId, ownProps.entityType),
    data: getAccessLevels(state, ownProps.entityId, ownProps.entityType),
    accessLevelsKey: getAccessLevelsKey(state)
});
const mapDispatchToProps = (dispatch) => ({
    onClose: () => dispatch(actionCreators.setAccessLevelsKey(undefined)),
    onInitialized: (objectId, entity) => {
        dispatch(usersActionCreators.getUsers());
        dispatch(parentActionCreators.getPermissions(objectId, entity));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(AccessLevelEditorPanel);
